const lightboxItems = document.querySelectorAll('.lightbox');
const body = document.body;

if(lightboxItems) {
    const imagesStructure = document.querySelectorAll('.structure-overview__texture');
    const imagesDecor = document.querySelectorAll('.collection__decors-item');

    [...imagesStructure, ...imagesDecor].forEach((img) => {
        img.addEventListener('click', function (e) {        
            let label = imagesDecor.length > 0 ? img.getElementsByClassName('collection__decors-label')[0].innerText : img.getElementsByClassName('structure-overview__headline')[0].innerText;
            
            lightboxItems.forEach((box) => {
                let lightboxLabel = box.getElementsByClassName('lightbox-item__label')[0].innerText.replace('| ', '') ;
                let btn = box.querySelector('.lightbox__close');
                
                if(label == lightboxLabel) {
                    box.style.display = 'block';
                    body.style.overflow = 'hidden';
                }

                btn.addEventListener('click', function () {
                    if (lightboxItems) {
                        box.style.display = 'none';
                        document.body.style.overflow = 'auto';
                    }
                });
            });
        });
    });
}
